import { authService } from '../auth/auth.service';
import { hasSingleStore } from '../auth/authHelpers';
import storeService from '../store/store.service';
import { urlService } from '@whiz-cart/ui-shared/url/url.service';

export default () => {
    return authService.loginState
        .map((state) => state.isLoggedIn)
        .subscribe((isLoggedIn, prevIsLoggedIn) => {
            if (isLoggedIn && !prevIsLoggedIn) {
                authService.claimMapping.get();
                storeService.allStores().get();
            }

            if (isLoggedIn && prevIsLoggedIn === false) {
                const singleStore = hasSingleStore(authService.loginState.get());
                if (singleStore) {
                    urlService.replaceUrl({ storeGuid: singleStore });
                }
            }
        });
};
